import { Component, OnInit } from '@angular/core';
import { Report } from 'notiflix/build/notiflix-report-aio';
import {HttpClient,HttpHeaders,HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
name:any;
email:any;
subject:any;
message:any;
  constructor(private http : HttpClient) { }

  ngOnInit() {
  }
  onSubmit() {
if(this.name==null  || this.name==""){
  Report.failure(
    'Name Missing',
    'Please fill Name in order to submit request !',
    'Okay',
    );
}else if(this.email==null || this.email==""){
  Report.failure(
    'Email Missing',
    'Please fill Email in order to submit request !',
    'Okay',
    );
}
else if(this.subject==null || this.subject==""){
  Report.failure(
    'Subject Missing',
    'Please fill Subject in order to submit request !',
    'Okay',
    );
}else{
  const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  let body = new HttpParams();
  body = body.set('Name', this.name);
  body = body.set('Email', this.email);
  body = body.set('Subject', this.subject);
  body = body.set('Message', this.message);
  body = body.set('Page', 'Contact US');
    this.http.post("https://admin.osit.com.sa/api/contactus", body).subscribe((data) => {
    
      Report.success(
        'Request Sent',
        'Your request is successfully sent to concerned department, we will contact you soon !',
        'Okay',
        );
        this.name="";
        this.email="";
        this.subject="";
        this.message="";
    });
 
}

  }
}

